var _defs, _rect, _g, _path, _path2, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-e5c7f122-0f1b-4b19-9c5c-6889aa78c8af",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 999.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .uuid-62d38246-e080-4da1-949c-8da049ea1590 {\r\n        fill: #f8f9fc;\r\n      }\r\n\r\n      .uuid-4369f9a8-dd2b-4c1f-ad39-0774d53a9dab {\r\n        fill: #fff;\r\n      }\r\n\r\n      .uuid-62a39dab-331c-448a-b564-30d7718238ac {\r\n        fill: #8e8e8e;\r\n      }\r\n\r\n      .uuid-d8d0b41a-25e4-4fe8-a07f-bbbf3fe1ee1c {\r\n        fill: url(#uuid-4264a60c-eba5-4200-af7e-7f887f6033d3);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-4264a60c-eba5-4200-af7e-7f887f6033d3",
    x1: -413.35,
    y1: 499.61,
    x2: 1169.92,
    y2: 499.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#150335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#320231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#55012e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#72012b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#880028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#980027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#a20026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a50026"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "uuid-d8d0b41a-25e4-4fe8-a07f-bbbf3fe1ee1c",
    x: 80.79,
    width: 999.21,
    height: 999.21,
    rx: 149.88,
    ry: 149.88
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4369f9a8-dd2b-4c1f-ad39-0774d53a9dab",
    cx: 174.83,
    cy: 241.31,
    r: 49.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4369f9a8-dd2b-4c1f-ad39-0774d53a9dab",
    cx: 174.83,
    cy: 499.61,
    r: 49.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4369f9a8-dd2b-4c1f-ad39-0774d53a9dab",
    cx: 174.83,
    cy: 757.9,
    r: 49.96
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-62a39dab-331c-448a-b564-30d7718238ac",
    d: "M174.84,266.27H24.98c-13.81,0-24.98-11.17-24.98-24.98s11.17-24.98,24.98-24.98h149.86c13.81,0,24.98,11.17,24.98,24.98s-11.17,24.98-24.98,24.98Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-62a39dab-331c-448a-b564-30d7718238ac",
    d: "M174.84,524.56H24.98c-13.81,0-24.98-11.17-24.98-24.98s11.17-24.98,24.98-24.98h149.86c13.81,0,24.98,11.17,24.98,24.98s-11.17,24.98-24.98,24.98Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-62a39dab-331c-448a-b564-30d7718238ac",
    d: "M174.84,782.91H24.98c-13.81,0-24.98-11.17-24.98-24.98s11.17-24.98,24.98-24.98h149.86c13.81,0,24.98,11.17,24.98,24.98s-11.17,24.98-24.98,24.98Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-62d38246-e080-4da1-949c-8da049ea1590",
    cx: 577.71,
    cy: 349.25,
    r: 107.93
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-62d38246-e080-4da1-949c-8da049ea1590",
    d: "M400.46,572.89l-17.73,16.85c-46.96,44.64-15.37,123.73,49.42,123.73h296.47c65.27,0,96.62-80.08,48.71-124.4l-20.11-18.61c-100.96-93.39-257.09-92.33-356.77,2.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsIcon);
export default __webpack_public_path__ + "static/media/ContactsIcon.ad3610a9e85b32d086f8d7e63418ab1c.svg";
export { ForwardRef as ReactComponent };